<template>
  <layout-content-horizontal-nav :nav-menu-items="publicMenusItems">
    <!-- Default Slot -->
    <slot></slot>

    <!-- Navbar -->
    <template #navbar="{ navIconClick }">
      <div class="navbar-content-container" :class="{ 'expanded-search': shallShowFullSearch }">
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <v-app-bar-nav-icon @click="navIconClick" v-if="$vuetify.breakpoint.mdAndDown"></v-app-bar-nav-icon>
          <v-menu v-if="userTenants.length" v-model="showMenu" absolute offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" text>
                <v-img :src="appLogo" max-height="30px" max-width="30px" alt="logo" contain class="ma-1"></v-img>
                <v-icon color="secondary">{{ icons.mdiMenuDown }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in userTenants" :key="index" @click="switchTenant(item)"
                class="ma-2 me-3">
                <v-list-item-avatar size="30">
                  <v-img :src="item.logo"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title bold>{{ item.tenant }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-img v-else :src="appLogo" max-height="30px" max-width="30px" alt="logo" contain class="me-3"></v-img> -->
          <router-link to="/" class="d-flex align-center text-decoration-none">
            <v-img v-if="!userTenants.length" :src="appLogo" max-height="30px" max-width="30px" alt="logo" contain
              class="me-3"></v-img>



            <h2 class="app-title text--primary">
              {{ appName }}
            </h2>

          </router-link>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center">
          <app-bar-search class="me-4"></app-bar-search>
          <app-bar-i18n></app-bar-i18n>
          <app-bar-theme-switcher></app-bar-theme-switcher>
          <app-bar-user-menu class="ms-2"></app-bar-user-menu>
        </div>
      </div>
      <v-overlay :value="$store.state.app.shallContentShowOverlay" z-index="5" absolute class="system-bar-overlay">
      </v-overlay>
    </template>

    <!-- Slot: footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span> </span>
        <div class="align-center d-none d-md-flex mr-7">
          <span>
            <template v-if="appVersion">
              Version {{ appVersion }}&nbsp;
            </template>
            &copy; {{ new Date().getFullYear() }} Piiri Kit Oy</span>&nbsp;&nbsp;

        </div>
      </div>
    </template>

    <!-- App Content -->
    <!-- <template #v-app-content>
      <app-customizer class="d-none d-md-block"></app-customizer>
    </template> -->
  </layout-content-horizontal-nav>
</template>

<script>
import LayoutContentHorizontalNav from "@core/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue";
import AppCustomizer from "@core/layouts/components/app-customizer/AppCustomizer.vue";
import useMenus from "@core/utils/useMenus";

// App Bar Components
import AppBarSearch from "@core/layouts/components/app-bar/AppBarSearch.vue";
import AppBarI18n from "@core/layouts/components/app-bar/AppBarI18n.vue";
import AppBarThemeSwitcher from "@core/layouts/components/app-bar/AppBarThemeSwitcher.vue";
import AppBarUserMenu from "@/components/AppBarUserMenu.vue";

import { ref } from "@vue/composition-api";

import themeConfig from "@themeConfig";
import { mdiHeartOutline, mdiMenuDown } from "@mdi/js";
import useAuth from "@/useAuth";
import useTerms from "@core/utils/useTerms";
import { i18n } from "@/plugins/i18n";

export default {
  components: {
    LayoutContentHorizontalNav,
    AppCustomizer,

    // App Bar Components
    AppBarSearch,
    AppBarThemeSwitcher,
    AppBarUserMenu,
    AppBarI18n,
  },
  setup() {
    const appVersion = process.env.VUE_APP_VERSION;
    const shallShowFullSearch = ref(false);

    const { publicMenusItems } = useMenus();

    const { tenant, getUserTenants, setToken } = useAuth();
    const showMenu = ref(false);

    const switchTenant = (tenant) => {
      setToken(tenant.token, tenant.expiry);
      window.location.href = "/home";
      // window.location.reload();
    }



    return {
      publicMenusItems,
      shallShowFullSearch,
      switchTenant,
      showMenu,
      appName: tenant.value.name,
      appLogo: tenant.value.logo.thumbnail,
      appVersion,
      userTenants: getUserTenants(),
      icons: {
        mdiHeartOutline,
        mdiMenuDown
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}
</style>
